import { RequestServiceEquipmentDetailsWrapper } from 'components/pcc-components';
import { Image } from 'components/image';
import styles from '../request-equipment-service.module.scss';

const RequestEquipmentServiceEquipmentInfo = ({ equipmentDetail }) => {
  const { imageURL, model, equipmentFamily } = equipmentDetail;

  const selectedEquipmentImageAlt = `${model} ${equipmentFamily}`;
  return (
    <div className="px-3 d-flex mt-md-2 mb-4 justify-content-md-start flex-md-row">
      <div className="flex-shrink-0 d-flex justify-content-md-start">
        <Image
          src={imageURL}
          alt={selectedEquipmentImageAlt}
          width={88}
          height={64}
          className={`${styles['request-service__image']} me-2 py-1`}
        />
      </div>
      <div className="d-flex flex-column justify-content-center overflow-hidden">
        <RequestServiceEquipmentDetailsWrapper
          equipmentDetail={equipmentDetail}
        />
      </div>
    </div>
  );
};
export default RequestEquipmentServiceEquipmentInfo;
